import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PasswordRequirement, StiiraError } from '@core/models';
import { AuthService, ErrorService, LayoutService, ProfileService, SnackbarService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate } from '@shared/helpers/rxjs.helpers';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { closeDialogOnEscape } from '@shared/helpers';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  static readonly componentName = 'ChangePasswordComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  public form: UntypedFormGroup;
  public hideCurrentPassword = true;
  public hideNewPassword = true;
  public isSubmitting$ = new Subject<boolean>();
  public isMobile$: Observable<boolean>;
  public passwordValid = true;

  get currentPassword(): FormControl {
    return this.form.get('currentPassword') as FormControl;
  }

  get newPassword(): FormControl {
    return this.form.get('newPassword') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private profileService: ProfileService,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private errorService: ErrorService,
    @Inject(MAT_DIALOG_DATA) public data: {
      sysText: any,
      passwordRequirements: PasswordRequirement[]
    },
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.isMobile$ = this.layoutService.isMobile$();
    closeDialogOnEscape(this.dialogRef, this.isSubmitting$, () => this.dialogRef.close());

    this.form = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required]
    });
  }

  changePassword(): void {
    this.profileService
      .changePassword({currentPassword: this.form.value.currentPassword, newPassword: this.form.value.newPassword})
      .pipe(
        indicate(this.isSubmitting$),
        finalize(() => { })
      )
      .subscribe(
        () => {
          this.snackbarService.open('Password successfully changed', 'Dismiss');
          this.authService.logout();
          this.dialogRef.close();
        },
        (err: StiiraError) => this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors)
      );
  }
}
